import { Pipe, PipeTransform } from '@angular/core';

/**
 *  This fulter is used to return a currency code by its key
 */

@Pipe({
  name: 'currencyCode'
})
export class CurrencyCode implements PipeTransform {

    test: {[key: string]: string};

    constructor(){
        this.test =  {
            'AFN' : '971',
            'ALL' : '008',
            'DZD' : '012',
            'AOA' : '973',
            'ARS' : '032',
            'AMD' : '051',
            'AWG' : '533',
            'AZN' : '944',
            'BSD' : '044',
            'BHD' : '048',
            'BDT' : '050',
            'BBD' : '052',
            'BYR' : '974',
            'BZD' : '084',
            'BMD' : '060',
            'BTN' : '064',
            'BOB' : '068',
            'BOV' : '984',
            'BAM' : '977',
            'BWP' : '072',
            'BRL' : '986',
            'BND' : '096',
            'BGN' : '975',
            'BIF' : '108',
            'CVE' : '132',
            'KHR' : '116',
            'CAD' : '124',
            'KYD' : '136',
            'CLF' : '990',
            'CLP' : '152',
            'CNY' : '156',
            'COP' : '170',
            'COU' : '970',
            'KMF' : '174',
            'CDF' : '976',
            'CRC' : '188',
            'HRK' : '191',
            'CUC' : '931',
            'CUP' : '192',
            'CZK' : '203',
            'DJF' : '262',
            'DOP' : '214',
            'EGP' : '818',
            'SVC' : '222',
            'ERN' : '232',
            'ETB' : '230',
            'FKP' : '238',
            'FJD' : '242',
            'XAF' : '950',
            'GMD' : '270',
            'GEL' : '981',
            'GHS' : '936',
            'GIP' : '292',
            'DKK' : '208',
            'GTQ' : '320',
            'GNF' : '324',
            'GYD' : '328',
            'HTG' : '332',
            'HNL' : '340',
            'HKD' : '344',
            'HUF' : '348',
            'ISK' : '352',
            'INR' : '356',
            'IDR' : '360',
            'XDR' : '960',
            'IRR' : '364',
            'IQD' : '368',
            'ILS' : '376',
            'JMD' : '388',
            'JPY' : '392',
            'JOD' : '400',
            'KZT' : '398',
            'KES' : '404',
            'KPW' : '408',
            'KRW' : '410',
            'KWD' : '414',
            'KGS' : '417',
            'LAK' : '418',
            'LBP' : '422',
            'LSL' : '426',
            'LRD' : '430',
            'LYD' : '434',
            'MOP' : '446',
            'MKD' : '807',
            'MGA' : '969',
            'MWK' : '454',
            'MYR' : '458',
            'MVR' : '462',
            'MRO' : '478',
            'MUR' : '480',
            'XUA' : '965',
            'MXN' : '484',
            'MXV' : '979',
            'MDL' : '498',
            'MNT' : '496',
            'MZN' : '943',
            'MMK' : '104',
            'NAD' : '516',
            'NPR' : '524',
            'NIO' : '558',
            'NGN' : '566',
            'OMR' : '512',
            'PKR' : '586',
            'PAB' : '590',
            'PGK' : '598',
            'PYG' : '600',
            'PEN' : '604',
            'PHP' : '608',
            'PLN' : '985',
            'QAR' : '634',
            'RON' : '946',
            'RUB' : '643',
            'RWF' : '646',
            'SHP' : '654',
            'XCD' : '951',
            'WST' : '882',
            'STD' : '678',
            'SAR' : '682',
            'RSD' : '941',
            'SCR' : '690',
            'SLL' : '694',
            'SGD' : '702',
            'ANG' : '532',
            'XSU' : '994',
            'EUR' : '978',
            'SBD' : '090',
            'SOS' : '706',
            'ZAR' : '710',
            'SSP' : '728',
            'LKR' : '144',
            'SDG' : '938',
            'SRD' : '968',
            'NOK' : '578',
            'SZL' : '748',
            'SEK' : '752',
            'CHE' : '947',
            'CHF' : '756',
            'CHW' : '948',
            'SYP' : '760',
            'TWD' : '901',
            'TJS' : '972',
            'TZS' : '834',
            'THB' : '764',
            'XOF' : '952',
            'NZD' : '554',
            'TOP' : '776',
            'TTD' : '780',
            'TND' : '788',
            'TRY' : '949',
            'TMT' : '934',
            'USD' : '840',
            'AUD' : '036',
            'UGX' : '800',
            'UAH' : '980',
            'AED' : '784',
            'GBP' : '826',
            'USN' : '997',
            'UYI' : '940',
            'UYU' : '858',
            'UZS' : '860',
            'VUV' : '548',
            'VEF' : '937',
            'VND' : '704',
            'XPF' : '953',
            'MAD' : '504',
            'YER' : '886',
            'ZMW' : '967',
            'ZWL' : '932'
        };
    }

    transform(key: string): string {
        return this.test[key];
    }

}
